<template>
  <div v-if="user != null">
    <form class="login" @submit.prevent="onSubmit">
      <h1>Passwort ändern</h1>
      <label>Passwort</label>
      <input
        required
        v-model="newPassword"
        type="password"
        placeholder="***********"
      />
      <label>Bestätigung</label>
      <input
        required
        v-model="newPasswordConfirmation"
        type="password"
        placeholder="***********"
      />

      <hr />
      <!-- Use computations mapping to map this to a more descriptive value -->
      <div v-if="user.passwordHash != null">
        <label>Altes Passwort</label>
        <input
          required
          v-model="oldPassword"
          type="password"
          placeholder="***********"
        />
      </div>
      <hr />
      <button type="submit">Ändern</button>
    </form>
  </div>
</template>

<style>
.login {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 10px;
}
</style>

<script>
import axios from "axios";

export default {
  name: "ChangePassword",
  data() {
    return {
      user: null,
      oldPassword: null,
      newPassword: null,
      newPasswordConfirmation: null,
    };
  },

  methods: {
    loadCurrentUser: function () {
      axios({
        method: "GET",
        url: process.env.VUE_APP_API_PATH + "user/GetUserData",
      }).then(
        (result) => {
          this.user = result.data;
        },
        (error) => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );
    },

    changePassword: function (newPassword, oldPassword = null) {
      const payload = {
          newPassword: newPassword,
          oldPassword: oldPassword,
      };

      axios({
        method: "PUT",
        url: process.env.VUE_APP_API_PATH + "user/ChangePassword",
        data: payload
      }).then(
        (result) => {
          alert("Passwort erfolgreich geändert!");
        },
        (error) => {
          console.error(error);
          alert("Passwort konnte nicht geändert werden!");
        }
      );
    },

    onSubmit: function () {
      if(this.newPassword != this.newPasswordConfirmation) {
        alert("Bitte bestätigen sie Ihr Passwort!");
        this.newPasswordConfirmation = "";
        return;
      }

      this.changePassword(this.newPassword, this.oldPassword);
    },
  },

  mounted() {
    this.loadCurrentUser();
  },
};
</script>
